import axios from 'axios';
import { useEffect } from 'react'
import { useParams } from 'react-router-dom';

function ShashiUnplugged() {
  const { token } = useParams();

  useEffect(() => {
    axios.post(`${process.env.REACT_APP_RESERVATION}/v1/magic-link-session/start-session`, { "app-token": token }).then((res) => {
      console.log(res);
      if (res.data?.result?.data?.storeUrl) {
        window.open(res.data?.result?.data?.storeUrl, '_self');
      }
    }).catch((err) => {
      console.log(err);
      alert(err?.response?.data?.result?.message || 'Something went wrong');
    })
  }, [])

  // useEffect(() => {
  //   const openApp = () => {
  //     const startTime = Date.now();
  //     let appOpened = false;

  //     // Create an invisible iframe and try opening the app with the schema
  //     const iframe = document.createElement('iframe');
  //     // iframe.style.display = 'none';
  //     window.location.href = `ShashiApp://?message=${token}`;

  //     document.body.appendChild(iframe);

  //     // Check if the app is opened by focusing on the window
  //     const checkAppOpened = () => {
  //       if (document.hasFocus()) {
  //         appOpened = true;
  //       }
  //     };

  //     // Listen for the focus event to detect if the app opened
  //     window.addEventListener('focus', checkAppOpened);

  //     // Set a timeout to detect if the app was opened
  //     setTimeout(() => {
  //       window.removeEventListener('focus', checkAppOpened);

  //       // If the app hasn't opened within the time limit, redirect to the App Store
  //       axios.post('http://192.168.168.140:8006/api/v1/magic-link-session/start-session' , {"app-token" : token}).then((res) => {
  //         console.log(res);
  //         if(res.data?.result?.data?.storeUrl) {
  //           // window.open(res.data?.result?.data?.storeUrl , '_self');
  //           if (!appOpened) {
  //             const userConfirmed = window.confirm('App not installed. Do you want to download it?');
  //             if (userConfirmed) {
  //               window.location.href = res.data?.result?.data?.storeUrl;
  //             }
  //           }
  //         }
  //       }).catch((err) => {
  //         console.log(err);
  //         alert(err?.response?.data?.result?.message || 'Something went wrong');
  //       })
  //       // Clean up iframe
  //       document.body.removeChild(iframe);
  //     }, 2000); // Check after 2 seconds (adjust based on your needs)
  //   };

  //   openApp();
  // }, [])



  return (
    <div>
      {/* {token} */}
    </div>
  )
}

export default ShashiUnplugged
